import Vue from "vue";
import VueI18n from "vue-i18n";
import en from "./locales/en.json";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "en",
  messages: { en },
});

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
};

const locale = getCookie("lang") || "dk";

export const loadMessages = async () => {
  if (locale in i18n.messages) {
    i18n.locale = locale;
  } else {
    await fetch(
      "https://webtranslateit.com/api/projects/proj_pub_AONe8FIGi_r68wpw0UvJJg/files/867950/locales/da-DK"
    )
      .then((response) => response.json())
      .then((messages) => {
        i18n.setLocaleMessage(locale, messages);
        i18n.locale = locale;
      })
      .catch((error) => {
        console.error(`Error getting translations: ${error}`);
      });
  }
};

export default i18n;
